var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderLog2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.667 0H117.333C87.9147 0 64 23.9147 64 53.3333V512H448V53.3333C448 23.9147 424.085 0 394.667 0ZM426.667 490.667H85.3333V53.3333C85.3333 35.6907 99.6907 21.3333 117.333 21.3333H394.667C412.309 21.3333 426.667 35.6907 426.667 53.3333V490.667ZM149.333 106.667H362.667V128H149.333V106.667ZM149.333 213.333H362.667V234.667H149.333V213.333ZM149.333 320H256V341.333H149.333V320Z",
    fill: "#155DF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderLog2);
export default __webpack_public_path__ + "static/media/Order Log 2.553f7a484baf7597ea24630b0dd64d20.svg";
export { ForwardRef as ReactComponent };